module.exports = __webpack_public_path__ + "media/fonts/Inter-ExtraBold-4164cfba.ttf";